import React from "react"
import classnames from "classnames"
import * as layouts from "layouts"
import * as bgscores from "brandguard/display/scores"
import { ScoreAccordionDescription } from "brandguard/components/layouts/scores"

interface props extends layouts.containers.FlexProps {
	explanation: string
}

// Display nests a model's explanation under its score row. The text already arrives on the
// event, so unlike the sibling explanation rows there is nothing to fetch.
export default function Display(props: React.PropsWithChildren<props>): JSX.Element {
	const { className, explanation, children, ...rest } = props

	if (explanation === "") return <>{children}</>

	return (
		<bgscores.SectionAccordion
			borderWidth="0"
			borderRadius="0"
			borderColor="unset"
			borderStyle="unset"
			borderBottom="none"
			my="0"
			className={classnames(className, bgscores.layouts.styledAccordion)}
			{...rest}
		>
			<layouts.containers.box tabIndex={0}>
				<bgscores.SectionDescription>
					<ScoreAccordionDescription padding="0" className={className}>
						{children}
					</ScoreAccordionDescription>
				</bgscores.SectionDescription>
				<layouts.accordions.Content>
					<layouts.Flex
						flexDirection="column"
						flex="1"
						pr="54px"
						className={classnames("explanation", className)}
					>
						<layouts.Flex flexDirection="column" my="10px" pl="35px" lineHeight="14px">
							<layouts.Box>{explanation}</layouts.Box>
						</layouts.Flex>
					</layouts.Flex>
				</layouts.accordions.Content>
			</layouts.containers.box>
		</bgscores.SectionAccordion>
	)
}
